<template>
  <el-form
    @submit.native.prevent="save"
    ref="form"
    label-position="top"
    id="notificactionForm"
    enctype="multipart/form-data"
  >
    <el-row type="flex" justify="space-between">
      <el-col :span="6" v-if="templateShow.title">
        <el-form-item label="Título" :class="(errorTitle ? 'error' : false)">
          <el-input v-model="template.title"></el-input>
          <div v-if="errorTitle" class="el-form-item__error">El título es obligatorio</div>
        </el-form-item>
      </el-col>
      <el-col :span="1"></el-col>
      <el-col :span="6" v-if="templateShow.date">
        <el-form-item label="Fecha publicación">
          <el-date-picker
            v-model="template.date"
            type="date"
            placeholder="Selecciona una fecha"
            format="dd/MM/yyyy"
            :picker-options="pickerOptions1"
          ></el-date-picker>
          <div v-if="errorDate" class="el-form-item__error">La fecha es obligatoria</div>
        </el-form-item>
      </el-col>
      <el-col :span="1"></el-col>
      <el-col :span="6" v-if="templateShow.link">
        <el-form-item label="Enlace">
          <el-input v-model="template.link"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="1"></el-col>
      <el-col :span="6" v-if="templateShow.section">
        <el-form-item label="Sección" v-if="sectionsApiShow">
          <el-select v-model="template.section_id" filterable placeholder="Select">
            <el-option-group v-for="group in sectionsApi" :key="group.label" :label="group.label">
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="templateShow.short_text">
      <el-col :span="24">
        <el-form-item label="Texto breve">
          <el-input template.text v-model="template.short_text"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row v-if="templateShow.text">
      <el-col :span="24">
        <el-form-item label="Texto" v-if="showEditor">
          <app-vue-editor :value="template.text"></app-vue-editor>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="templateShow.image">
      <app-cropper :options="options"></app-cropper>
    </el-row>
  </el-form>
</template>

<script>
import ApiService from "@/common/api.service";
import { API_UPLOADS } from "@/common/config";
import Cropper from "@/components/Dashboard/commons/cropper.vue";
import Editor from "@/components/_commons/vue-editor";
import moment from "moment-timezone";

export default {
  name: "NotificationForm",
  props: ["tipeTemplate", "notification"],
  components: {
    "app-vue-editor": Editor,
    "app-cropper": Cropper
  },
  async created() {
    this.$root.$on("imagenCargada", file => {
      this.template.image = file;
    });
    this.$root.$on("imagenEliminada", () => (this.template.image = ""));
    if (this.notification) {
      this.template = await this.notification;
      this.showEditor = true;
      if (this.notification.image && this.notification.image != 0) {
        this.options.img = (await API_UPLOADS) + this.notification.image;
      } else {
        this.options.img = null;
      }
    }
    this.$root.$on("saveContent", id => {
      this.id = id;
      this.desktop_id = id;
      this.setSave();
    });
    await this.getSections();
    await this.showTemplate();
    this.$root.$on("vue-editor", e => {
      this.template.text = e;
    });
  },
  watch: {
    tipeTemplate: function(newVal, oldVal) {
      this.show = false;
      this.tipeTemplate = newVal;
      setTimeout(() => {
        this.showTemplate();
      }, 200);
    }
  },
  data() {
    return {
      // Show,s
      show: false,

      // Form
      table: "notifications",
      id: null,
      desktop_id: null,
      content: 0,
      template: {
        title: "",
        text: "",
        short_text: "",
        image: false,
        link: "",
        date: ""
      },
      templateShow: false,
      errorTitle: false,
      errorDate: false,

      // Crooper
      options: {
        img: null,
        size: 1,
        outputType: "jpg",
        canMove: true,
        canMoveBox: false,
        class: "cropper-medium",
        info: true,
        canScale: true,
        autoCrop: true,
        autoCropHeight: 220,
        autoCropWidth: 431,
        fixed: false,
        fixedBox: true,
        centerBox: true,
        fixedNumber: [431, 220]
      },
      sectionsApi: [],
      sectionsApiShow: false,
      showEditor: true,
      pickerOptions1: {
        firstDayOfWeek: 1
      }
    };
  },

  methods: {
    save() {
      // método creado para solventar error de crooper al terminar edición
    },
    async getSections() {
      const response = await ApiService.post("dashboard/sections-page", {
        table: "notifications",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table")
      });
      const a = await response.data
        .map(e => {
          return e.pagina;
        })
        .filter(function(item, pos, self) {
          return self.indexOf(item) == pos;
        })
        .map(e => {
          return { label: e, options: [] };
        })
        .map(o => {
          response.data.map(e => {
            if (o.label == e.pagina) {
              o.options.push({
                value: e.id,
                label: e.title
              });
              return e;
            }
          });
          return o;
        });
      a.unshift({
        label: "Ninguno",
        options: [{ label: "Ninguna", value: "1" }]
      });

      this.sectionsApi = a;
      this.sectionsApiShow = true;

      //
    },
    async setSave() {
      if (this.template.title == "") {
        this.$message({
          type: "error",
          message: "El campo título es obligatorio"
        });
        this.errorTitle = true;
        return false;
      } else if (this.template.date == "") {
        this.$message({
          type: "error",
          message: "El campo fecha es obligatorio"
        });
        this.errorDate = true;
        return false;
      } else {
        this.errorTitle = false;
        this.errorDate = false;
        if (this.template.image) {
          if (this.template.image.size) {
            let data = new FormData();
            data.append("file", this.template.image);
            const a = await ApiService.post("upload/contenido", data);
            this.template.image = a.data;
          } else if (this.template.image) {
            this.template.image = this.template.image;
          } else {
            this.template.image = "";
          }
        }

        if (this.template.date) {
          this.template.date = moment(this.template.date)
            .tz("Europe/Madrid")
            .format("YYYY-MM-DD");
        }

        if (this.$route.params.notification_id) {
          await this.update();
        } else {
          await this.insert();
        }
        this.$root.$emit("finishNotificationSave", true);
      }
    },
    async update() {
      await ApiService.post("dashboard/editform", {
        table: "notifications",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.template,
        id: this.$route.params.notification_id
      });
    },
    async insert() {
      console.log("insert");
      const a = await ApiService.post("dashboard/editform", {
        table: "notifications",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.template
      });
      if (a.status === 200) {
        await ApiService.post("dashboard/editform", {
          table: "desktop_notificactions",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          form: {
            desktop_id: this.desktop_id,
            notificaction_id: a.data
          }
        }).then(() => {
          location.reload();
        });
      }
    },
    async showTemplate() {
      if (parseInt(this.tipeTemplate) == 1) {
        await this.fecthDesktopScroll();
      } else if (parseInt(this.tipeTemplate) == 2) {
        await this.fecthDesktopPaginatorImage();
      } else if (parseInt(this.tipeTemplate) == 3) {
        await this.fecthDesktopPaginatorNoImage();
      } else if (parseInt(this.tipeTemplate) == 4) {
        await this.fecthDesktopBanner();
      }
    },
    fecthDesktopScroll() {
      this.templateShow = {
        title: true,
        text: true,
        short_text: false,
        image: false,
        link: true,
        date: true,
        section: true
      };
    },
    fecthDesktopPaginatorImage() {
      this.templateShow = {
        title: true,
        text: true,
        short_text: false,
        image: true,
        link: true,
        date: true,
        section: true
      };
    },
    fecthDesktopPaginatorNoImage() {
      this.templateShow = {
        title: true,
        text: true,
        short_text: false,
        image: false,
        link: true,
        date: true,
        section: true
      };
    },
    fecthDesktopBanner() {
      this.templateShow = {
        title: true,
        text: false,
        short_text: true,
        image: true,
        link: true,
        date: true,
        section: true
      };
    },
    getErrors() {
      if (this.errorTitle == true || this.errorDate == true) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/home/notificationform.vue